import { Reveal } from "@/components/site/Reveal";

const chapters = [
  {
    num: "01",
    title: "Crafted by hand",
    body: "Every candle is poured by hand in small batches — no rushing, no shortcuts. Just patience, high-quality wax and fragrances chosen with care.",
    img: "https://customer-assets.emergentagent.com/job_luxe-candles-shop-1/artifacts/5rma1dqd_WhatsApp%20Image%202026-07-06%20at%2011.58.18.jpeg",
  },
  {
    num: "02",
    title: "Made to brighten",
    body: "From charming decorative candles to delightful scented pours and floral bouquets — each piece is designed to bring warmth to your home and your heart.",
    img: "https://images.unsplash.com/photo-1612179543058-ab74d388e0ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxmbG9yYWwlMjBjYW5kbGV8ZW58MHx8fHwxNzgzNjYwMzg1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "03",
    title: "Room to create",
    body: "Our plaster figurines and DIY kits inspire creativity for children and hobbyists alike — ready to paint, decorate and gift, for endless afternoons of fun.",
    img: "https://customer-assets.emergentagent.com/job_luxe-candles-shop-1/artifacts/dgmb3r31_ChatGPT%20Image%20Jul%2010%2C%202026%2C%2001_08_32%20PM.png",
  },
];

export default function Manifesto() {
  return (
    <section id="story" className="max-w-7xl mx-auto px-6 py-28 sm:py-36" data-testid="story-section">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#C4A47C]" />
          <span className="label text-[#C4A47C]">Our Story</span>
        </div>
        <h2 className="font-serif font-light text-4xl sm:text-6xl tracking-tighter text-[#F5F5F0] max-w-3xl leading-[1.02]">
          A small studio with a warm obsession for detail.
        </h2>
      </Reveal>

      <div className="mt-24 space-y-28">
        {chapters.map((c, i) => (
          <div
            key={c.num}
            className={`grid md:grid-cols-12 gap-8 md:gap-14 items-center ${
              i % 2 === 1 ? "md:[direction:rtl]" : ""
            }`}
          >
            <Reveal className="md:col-span-7 [direction:ltr]">
              <div className="img-zoom rounded-sm border border-[#292524]">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-[340px] sm:h-[520px] object-cover"
                />
              </div>
            </Reveal>
            <div className="md:col-span-5 [direction:ltr]">
              <Reveal delay={0.1}>
                <span className="font-serif text-6xl text-[#292524]">{c.num}</span>
                <h3 className="font-serif text-3xl sm:text-4xl text-[#F5F5F0] tracking-tight mt-4">
                  {c.title}
                </h3>
                <p className="mt-5 text-[#A8A29E] font-light leading-relaxed max-w-md">{c.body}</p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
